module.exports = __webpack_public_path__ + "img/fdd22db.jpg";